<template>
    <div class="webapp">
        <h2 class="font-weight-bold">Find top developer for Web Application</h2>
            <button class="btn-outline-kovatek text-uppercase mt-2">get started</button>

            <div class="top-devs m-auto">
        <div class="px-sm-4 px-lg-4 mx-auto my-5 pb-4">
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Mike. P" image="mike.png" specialization="Back-end Developer" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" level="senior" rating="9.1" reviews="43"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Johnson. K" image="developer-1.png" specialization="Web Developer" charge="25" location="Lagos, Nigeria" :skills="['Django', 'Flask', 'Rails']" level="intermediate" rating="9.5" reviews="56"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Adara. W" image="developer-2.jpeg" specialization="Front-end Developer" charge="18" location="Ogun, Nigeria" :skills="['Reactjs', 'Nodejs', 'Go']" level="intermediate" rating="8.7" reviews="73"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Idirs. A" image="developer-3.png" specialization="Full Stack Developer" charge="32" location="Ibadan, Nigeria" :skills="['PHP', 'Python', 'Java']" level="senior" rating="9.0" reviews="20"/>
                    </div>

                </div>
            </div>
    </div>

            <HowItWorks />
            <Footer/>
    </div>
</template>

<script>

import TopRatedDev from '@/components/TopRatedDev.vue';
import Footer from '@/components/Footer.vue';
import HowItWorks from '@/components/HowItWorks.vue';

export default {
    name: 'webapp',
    components: {
        TopRatedDev, Footer, HowItWorks
    }
}
</script>

<style scoped>
.btn-outline-kovatek{
  background-color: #20409a;
  border: solid 1px #20409a;
  outline: 0;
  color: #fff;
  width: 200px;
  height: 50px;
  transition: .25s;
  border-radius: 5px;
  font-size: 16px;
}
.btn-outline-kovatek:hover{
  background-color: #fff;
  border: solid 1px #20409a;
  color: #20409a;
}
</style>